"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GenericIndexSceneTranslation = {
    fi: {
        GenericIndexScene: {
            addNew: 'Luo uusi',
        },
    },
    en: {
        GenericIndexScene: {
            addNew: 'Add new',
        },
    },
};
exports.default = GenericIndexSceneTranslation;
//# sourceMappingURL=_GenericIndexScene.translation.js.map